import { render, staticRenderFns } from "./SimilarTitles.vue?vue&type=template&id=02f99530"
import script from "./SimilarTitles.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimilarTitles.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports